import { useQuery } from '@tanstack/react-query'
import { auditApi, type AuditLogQuery } from '@/api/audit'

export function useAuditLogs(query: AuditLogQuery) {
	return useQuery({
		queryKey: ['audit-logs', query],
		queryFn: () => auditApi.listLogs(query),
	})
}

export function useAuditOptions() {
	return useQuery({
		queryKey: ['audit-options'],
		queryFn: auditApi.listOptions,
		staleTime: 5 * 60 * 1000,
	})
}
